<template>
  <v-badge
    v-if="showBadge"
    :content="badgeText"
    :color="badgeColor"
    floating
    offset-x="-4"
    offset-y="-4"
    class="feature-badge-wrapper"
  >
    <slot />
  </v-badge>
  <slot v-else />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useFeatureTour } from '@/composables/useFeatureTour'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  selector: string
}>()

const { t } = useI18n()
const { isBadgeVisible, getBadgesForPage } = useFeatureTour()

const showBadge = computed(() => isBadgeVisible(props.selector))

const badgeConfig = computed(() => {
  const badges = getBadgesForPage('')
  return badges.find(b => b.selector === props.selector)
})

const badgeText = computed(() => {
  const key = badgeConfig.value?.text
  return key ? t(key) : ''
})

const badgeColor = computed(() => badgeConfig.value?.color ?? 'error')
</script>

<style scoped lang="scss">
.feature-badge-wrapper {
  :deep(.v-badge__badge) {
    font-size: 11px;
    font-weight: 700;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    border-radius: 10px;
  }
}
</style>
